import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { EllipsisDropdownItem } from "@similarweb/ui-components";

export const EllipsisDropdownItemStyled = styled(EllipsisDropdownItem)`
    svg {
        height: 100%;
        width: 100%;
        fill: ${colorsPalettes.carbon[200]};
    }

    div[data-automation-icon-name="open-new-window"] svg {
        height: 19px;
        width: 19px;
    }
`;

export const DropdownActionItem = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px;
    cursor: pointer;
    max-width: 100%;
    transition:
        background-color 0.2s ease,
        color 0.2s ease;

    &:hover {
        background-color: ${colorsPalettes.blue[100]};
        border-radius: 4px;
        color: ${colorsPalettes.blue[400]};

        svg path {
            fill: ${colorsPalettes.blue[400]} !important;
        }

        .SWReactIcons {
            display: inline-block;
        }
    }

    .SWReactIcons {
        display: none;
        height: 16px;
        width: 10px;
        flex: 0 0 auto;

        svg {
            height: 100% !important;
            width: 100% !important;
        }
    }
`;

export const CellSiteWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    max-width: 98%;
`;

export const DropdownActionItemContent = styled.div`
    flex: 1 1 auto;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;
